import { FormattedMessage } from 'react-intl';
import { Link, Stack, Typography } from '@mui/material';

export const UnableToVerify = () => (
  <Stack alignItems="center" justifyContent="center">
    <Typography gutterBottom textAlign="center" variant="h2">
      <FormattedMessage defaultMessage="Unable to verify the information provided" />
    </Typography>
    <Typography gutterBottom sx={{ maxWidth: 450 }} textAlign="center" variant="body1">
      <FormattedMessage
        defaultMessage="In order for you to access these features, Plooto must verify your identity and company details. If you think you've received this message in error, contact our team at {emailLink}."
        values={{
          // Email address is a valid literal string
          // eslint-disable-next-line formatjs/no-literal-string-in-jsx
          emailLink: <Link href="mailto:verification@plooto.com">verification@plooto.com</Link>,
        }}
      />
    </Typography>
  </Stack>
);
